var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.name !== 'UserLogout')?_c('headTop'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath}),(_vm.$route.name !== 'UserLogout')?_c('bottomCom'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }